import React, { useState } from 'react';
import { useIntl, type MessageDescriptor } from 'react-intl';
import { Checkbox, Stack, Text, Title } from '@mantine/core';

import { SimpleModal } from '../../../../../components/simple-modal';
import { messages } from '../../messages';

type PackageConfigAlertModalProps = {
  heading: MessageDescriptor;
  message: MessageDescriptor;
  onConfirm: (shouldHideInFuture: boolean) => void;
  onCancel: () => void;
};

export const PackageConfigAlertModal = ({ heading, message, onConfirm, onCancel }: PackageConfigAlertModalProps) => {
  const intl = useIntl();
  const [shouldHideInFuture, setShouldHideInFuture] = useState(false);

  return (
    <SimpleModal
      actionMessage={messages.confirmButton}
      cancelMessage={messages.cancelButton}
      headerMessage={messages.packageModalAlertTitle}
      onAction={() => onConfirm(shouldHideInFuture)}
      onCancel={onCancel}
      onClose={onCancel}
      size='medium'
    >
      <Stack gap='md'>
        <Title mb='xs' order={4}>
          {intl.formatMessage(heading)}
        </Title>
        <Text size='sm'>{intl.formatMessage(message)}</Text>
        <Checkbox
          checked={shouldHideInFuture}
          label={intl.formatMessage(messages.dontShowAgainCheckbox)}
          onChange={(event) => setShouldHideInFuture(event.currentTarget.checked)}
        />
      </Stack>
    </SimpleModal>
  );
};
